// btw-front/src/components/layout/Footer.jsx
import React from "react";
import Container from "../ui/Container";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  const LOGO_SRC = `${process.env.PUBLIC_URL}/images/btwsoft/logo_b_3.png`;

  return (
    <footer className="border-t border-white/5 bg-slate-950 text-slate-300">
      <Container className="py-12">
        <div className="grid gap-8 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2.5">
              <img
                className="h-9 w-9 rounded-xl object-contain ring-1 ring-white/15"
                src={LOGO_SRC}
                alt="Between Soft logo"
                loading="eager"
              />
              <div className="leading-tight">
                <div className="text-base font-bold tracking-tight bg-gradient-to-r from-white to-cyan-200 bg-clip-text text-transparent">
                  BetweenSoft
                </div>
                <div className="text-[11px] font-medium tracking-wider text-accent/90">
                  비트윈소프트
                </div>
              </div>
            </div>

            <p className="mt-4 whitespace-pre-line text-sm leading-relaxed text-slate-400">
              {t("footer.desc")}
            </p>
          </div>

          <div className="text-sm">
            <div className="font-semibold text-white">{t("footer.linksTitle")}</div>
            <div className="mt-3 flex flex-col gap-2 text-slate-400">
              <a href="#about" className="w-fit transition-colors hover:text-white">
                {t("footer.links.about")}
              </a>
              <a href="#services" className="w-fit transition-colors hover:text-white">
                {t("footer.links.services")}
              </a>
              <a href="#certbear" className="w-fit transition-colors hover:text-white">
                {t("footer.links.certbear")}
              </a>
              <a href="#contact" className="w-fit transition-colors hover:text-white">
                {t("footer.links.contact")}
              </a>
            </div>
          </div>

          <div className="text-sm">
            <div className="font-semibold text-white">{t("footer.contactTitle")}</div>
            <div className="mt-3 space-y-2 text-slate-300">
              <div>support@btwsoft.com</div>
              <div>+82-02-6677-5900</div>
              <div className="text-xs text-slate-500">{t("footer.mailNote")}</div>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-white/10 pt-6 text-xs text-slate-500 md:flex-row md:items-center md:justify-between">
          <div>
            © {year} BetweenSoft. {t("footer.bottom.rights")}
          </div>
          <div className="flex gap-4">
            <a className="transition-colors hover:text-white" href="#top">
              {t("footer.bottom.top")}
            </a>
            <a className="transition-colors hover:text-white" href="#contact">
              {t("footer.bottom.contact")}
            </a>
          </div>
        </div>
      </Container>
    </footer>
  );
}
